import { render, staticRenderFns } from "./chain-list.vue?vue&type=template&id=accf5e5c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./chain-list.vue?vue&type=script&lang=js&"
export * from "./chain-list.vue?vue&type=script&lang=js&"
import style0 from "./chain-list.vue?vue&type=style&index=0&id=accf5e5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accf5e5c",
  null
  
)

export default component.exports